import React from 'react';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import {  listRewardPunishment } from '../../../modules/empModule/empResume';
import RewardPunishmentForm from '../../../components/employeemng/resume/RewardPunishmentForm';

const RewardPunishmentFormContainer = ({ employee }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    attrVal1: '',
    attrVal2: '',
    attrVal3: '',
    attrVal4: '',
    attrVal5: '',
    attrVal6: '',
  };

  const validationSchema = yup.object({
    attrVal1: yup.string('').required('상벌조항명을 입력하세요'),
    attrVal2: yup.string().required('종류를 입력하세요'),
    attrVal3: yup.date().required('등록일자를 입력하세요'),
    attrVal4: yup.string().nullable(),
    attrVal5: yup.string().nullable(),
    attrVal6: yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'REWARD_PUNISHMENT',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3
        ? dayjs(values.attrVal3).format('YYYY-MM-DD')
        : dayjs(new Date()).format('YYYY-MM-DD'),
        attrVal4: values.attrVal4,
        attrVal5: values.attrVal5,
        attrVal6: values.attrVal6,
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listRewardPunishment({
              id: employee.usrUuid,
              infoTyp: 'REWARD_PUNISHMENT',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <RewardPunishmentForm formik={formik} />;
};

export default RewardPunishmentFormContainer;
